import React from "react";
import styled from "styled-components";
import { layout } from "styled-system";
import css from "@styled-system/css";
import { Box } from "@bca/ui-library";

interface KeydecisionMakerContainerPropTypes {
  children: React.ReactNode;
  minHeight?: string;
}

export const StyledKeyDecisionMakerContainer = styled(Box)<{
  minHeight?: string;
}>`
  display: flex;
  gap: 6px;
  flex-direction: column;
  min-height: ${(props) => props.minHeight || "48px"};
  min-width: fit-content;
  ${layout}
  ${css({
    alignItems: ["flex-start", "center"],
    justifyContent: ["start", "center"],
  })}
`;

const KeyDecisionMakerContainer = ({
  children,
  minHeight,
}: KeydecisionMakerContainerPropTypes) => {
  return (
    <StyledKeyDecisionMakerContainer minHeight={minHeight}>
      {children}
    </StyledKeyDecisionMakerContainer>
  );
};

export default KeyDecisionMakerContainer;
